'use client'

import { Button } from '@/components/ui/button'
import { ArrowLeft } from 'lucide-react'

interface GoBackButtonProps {
  children?: React.ReactNode
  className?: string
  variant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link"
}

export function GoBackButton({ 
  children = (
    <>
      <ArrowLeft className="w-4 h-4 mr-2" />
      Go Back
    </>
  ),
  className = "w-full",
  variant = "ghost"
}: GoBackButtonProps) {
  return (
    <Button 
      variant={variant} 
      className={className}
      onClick={() => window.history.back()}
    >
      {children}
    </Button>
  )
}